import IdentificationPage from "./IdentificationPage"

export default IdentificationPage
